<template>
  <div class="pt-2 relative text-text-secondary md:w-80">
    <t-input
      :value="getSearchText"
      class="w-full"
      variant="nav"
      type="search"
      name="search"
      style="font-size: 14px;"
      placeholder="Search"
      autocomplete="false"
      @input="updateSearchText($event)"
      @search="search"
      @keyup.enter="search"
    />
    <button
      type="button"
      class="absolute right-0 top-0 mt-5 mr-4"
      @click="search"
      @click.prevent="onClickButton"
    >
      <svg
        id="Capa_1"
        class="text-text-secondary h-4 w-4 fill-current"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 56.966 56.966"
        style="enable-background: new 0 0 56.966 56.966;"
        xml:space="preserve"
        width="512px"
        height="512px"
      >
        <path
          d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions, } from 'pinia';
import { useSearchStore, } from '../../stores/search';

export default {
  name: 'SearchNav',
  props: {
    variant: {
      type: String,
      default: 'nav',
    },
  },
  emits: ['clicked'],
  computed: {
    ...mapState(useSearchStore, ['getSearchText']),
  },
  methods: {
    ...mapActions(useSearchStore, [
      'updateSearchText', 'applyFilters', 'clearExceptSearchText', 'clearLocalStorage',
    ]),
    search() {
      if (this.getSearchText.length > 0) {
        // clear all filters... except  search text
        this.clearExceptSearchText();
        this.clearLocalStorage();
      }
      if (this.$route.path.match('^/courses')) {
        // apply the search filters
        this.applyFilters();
      }
      else {
        // we only want to go to `/courses` when there is search text
        if (!this.getSearchText) {
          return;
        }
        // go to the search page and do actual searching!?!
        this.$router.push('/courses');
      }
    },
    onClickButton() {
      this.$emit('clicked');
    },
  },
};
</script>
